import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';

Alpine.plugin(persist);
window.Alpine = Alpine;

// Shared collapse behaviour for the personalization accordions (PFBB-51). One
// state polarity (`collapsed`), one persist idiom, one toggle — reused by the
// Tour (sidebar-box), Suggestions and Onboarding widgets so the dropdown is not
// re-implemented per widget. `tick` is bumped by the host root on resize / tab
// change so the collapsible body re-measures its scrollHeight when it reflows.
window.hubbsCollapse = (key, defaultCollapsed = false) => ({
  collapsed: key ? Alpine.$persist(defaultCollapsed).as(key) : defaultCollapsed,
  tick: 0,
  // `bodyOpen` is true only while the collapsible body is settled fully open, so
  // the body can drop `overflow-hidden` then and let an absolutely-positioned
  // popover (e.g. a suggestion card's share tooltip) escape instead of being
  // clipped by the max-height collapse container (PFBB-69 AC1).
  bodyOpen: false,
  // `animating` gates the max-height transition to a collapse/expand only, where
  // the body must clip so content does not spill past the shrinking/growing box.
  // A tab re-measure (tick, `collapsed` unchanged) leaves it false, so the height
  // snaps and the open body is never re-clipped mid-interaction — the share
  // popover keeps escaping right after a tab switch.
  animating: false,
  init() {
    // Settle to the reconciled collapsed pose on hydrate (the pre-paint already
    // set the body's max-height), so an initially-open box is not clipped and an
    // initially-collapsed one stays clipped — no boot flip.
    this.bodyOpen = !this.collapsed;
  },
  toggle() {
    // Arm the transition and clip before the height changes, then flip on a later
    // frame so the transition class is committed first and the collapse/expand
    // actually animates (a same-frame class+value change snaps). Tab re-measures
    // never call this, so they leave `animating` false and snap without clipping.
    this.animating = true;
    this.bodyOpen = false;
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        this.collapsed = !this.collapsed;
      }),
    );
  },
  // Called by the collapse-body when its max-height transition ends: a settled
  // box is open iff it is not collapsed, and it stops animating.
  settleBody() {
    this.animating = false;
    this.bodyOpen = !this.collapsed;
  },
});

Drupal.behaviors.alpinejs = {
  isStarted: false,
  attach() {
    if (Drupal.behaviors.alpinejs.isStarted === false) {
      Alpine.start();
      Drupal.behaviors.alpinejs.isStarted = true;
    }
  },
};
